import { Box, Typography } from "@mui/material";
import React from "react";

export default function CHUTOULOUSETerms() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <Typography variant="h2">Mentions légales</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="body1">
          En vertu de l’article 6 de la Loi n°2004-575 du 21 juin 2004 pour la
          confiance dans l’économie numérique, il est précisé dans cet article
          l’identité des différents intervenants dans le cadre de la réalisation
          et du suivi du présent site internet.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Éditeur du Site</Typography>
        <Typography variant="body1">
          CHU de Toulouse
          <br />
          Hôtel-Dieu Saint-Jacques
          <br />
          2 rue Viguerie
          <br />
          TSA 80035
          <br />
          31059 Toulouse Cedex 9
          <br />
          Tél : +33 (0)5 61 77 22 33
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Conception du Site</Typography>
        <Typography variant="body1">
          DOCAPOSTE
          <br />
          45-47, boulevard Paul Vaillant-Couturier
          <br />
          94200 Ivry-sur-Seine
          <br />
          Tél : (+33) 05 57 89 65 00
          <br />
          Contact : info@maincare.fr
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Hébergement du Site</Typography>
        <Typography variant="body1">
          DOCAPOSTE
          <br />
          45-47, boulevard Paul Vaillant-Couturier
          <br />
          94200 Ivry-sur-Seine
          <br />
          Tél : (+33) 05 57 89 65 00
          <br />
          Contact : info@maincare.fr
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Directeur de la publication</Typography>
        <Typography variant="body1">Monsieur Jean-François LEFEBVRE</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Statut de l’organisation éditrice</Typography>
        <Typography variant="body1">
          Etablissement public de santé régit par les articles L6162-1 et
          suivant du Code de la Santé Publique.
        </Typography>
      </Box>
      <Typography variant="h2">Conditions générales d’utilisation</Typography>
      <Typography variant="body1">
        NOUS VOUS REMERCIONS DE BIEN VOULOIR LIRE ATTENTIVEMENT LES PRESENTES
        CONDITIONS GENERALES D’UTILISATION (CI-APRES DENOMMEES « CGU ») DU
        SERVICE E-CONSENTEMENT. CELLES-CI CONTIENNENT DES INFORMATIONS
        IMPORTANTES RELATIVES A VOS DROITS, RECOURS ET OBLIGATIONS.
        <br />
        <br />
        L’UTILISATION DU SERVICE E-CONSENTEMENT SUPPOSE L’ACCEPTATION SANS
        RESERVE DES PRESENTES CONDITIONS GENERALES D’UTILISATION QUI S’IMPOSENT
        A CHACUN DES UTILISATEURS.
        <br />
        <br />
        LES PARTIES DECLARENT AVOIR REÇU TOUTES LES INFORMATIONS NECESSAIRES,
        PREALABLEMENT A LEUR ENGAGEMENT, AU MOYEN DES PRESENTES CGU AINSI QUE DE
        TOUT AUTRE DOCUMENT QUI POURRAIT ETRE PORTE A LEUR CONNAISSANCE.
        <br />
        <br />
        EN CONSEQUENCE, VOUS RECONNAISSEZ AVOIR PRIS CONNAISSANCE DES PRESENTES
        CONDITIONS GENERALES D’UTILISATION QUE VOUS VOUS ENGAGEZ A RESPECTER.
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Préambule</Typography>
        <Typography variant="body1">
          Le présent document a pour objet de définir les modalités et
          conditions dans lesquelles le Centre Hospitalier de Toulouse, ci-après
          dénommé « le CHU de Toulouse », met à la disposition des Utilisateurs
          le Service E-Consentement (ci-après le « Service »), accessible à
          l’adresse URL
          {" "}
          <a href="https://www.consentements.teleservices-sante-docaposte.fr/">
            https://www.consentements.teleservices-sante-docaposte.fr/
          </a>
          <br />
          <br />
          L’Utilisateur accède et utilise le Service mis à sa disposition par le
          CHU de Toulouse dans les conditions décrites aux présentes CGU.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Définitions</Typography>
        <Typography variant="body1">
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            Espace Patient
          </span>
          {" "}
          : Accès à la plateforme E-Consentement réservée à tout patient
          ou son Représentant légal dont ce dernier a la possibilité de
          s’opposer à l’intégration de ses données dans l’Entrepôt de Données de
          Santé (ci-après « EDS » du CHU de Toulouse ;
        </Typography>
        <Typography variant="body1">
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            HDS
          </span>
          {" "}
          : Hébergeur de données de santé ;
        </Typography>
        <Typography variant="body1">
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            Patient ou Utilisateur
          </span>
          {" "}
          : une personne physique identifiée ou identifiable prise en
          charge au sein du CHU de Toulouse et dont ses données sont traitées
          pour intégration dans l’EDS.
        </Typography>
        <Typography variant="body1">
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            Plateforme E-Consentement
          </span>
          {" "}
          : Plateforme accessible en ligne « Saas » (Software as a
          service) par laquelle le Patient peut accéder au service, prendre
          connaissance dudit traitement de données et le cas échéant, pour
          exercer ses droits ;
        </Typography>
        <Typography variant="body1">
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            Représentant légal
          </span>
          {" "}
          : Personne physique légalement désignée pour représenter le
          Patient en raison de sa qualité de titulaire de l’autorité parentale
          ou de curateur ou de tuteur. Le Représentant légal agit au nom et pour
          le compte du Patient ;
        </Typography>
        <Typography variant="body1">
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            Service
          </span>
          {" "}
          : Toutes les fonctionnalités disponibles sur la plateforme en
          ligne à travers l’espace Patient. Le Service comprend l’horodatage
          d’authentification et un hébergement sécurisé certifié pour les
          données de santé
        </Typography>
        <Typography variant="body1">
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            Site
          </span>
          {" "}
          : Site internet accessible à l’adresse
          {" "}
          <a href="https://www.consentements.teleservices-sante-docaposte.fr">
            https://www.consentements.teleservices-sante-docaposte.fr
          </a>
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Objet du service</Typography>
        <Typography variant="body1">
          E-Consentement est un service en ligne permettant au Patient ou à son
          Représentant légal, de s’opposer aux traitements de données, avec
          horodatage via la plateforme accessible à partir de l’adresse URL
          unique :
          {" "}
          <a href="https://www.consentements.teleservices-sante-docaposte.fr">
            https://www.consentements.teleservices-sante-docaposte.fr
          </a>
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Champ d’application des CGU</Typography>
        <Typography variant="body1">
          Les présentes conditions générales d’utilisation ont pour objet de
          déterminer les conditions et modalités d’utilisation par le Patient ou
          son représentant légal de la plateforme. Lors de son authentification
          en ligne, l’Utilisateur reconnait avoir pris connaissance des mentions
          légales des conditions générales d’utilisation qu’il s’engage à
          respecter. Le CHU de Toulouse se réserve le droit de bloquer ou
          limiter l’utilisation du Service en cas d’utilisation inappropriée ou
          frauduleuse.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">
          Description du service E-Consentement
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            La Plateforme est un service en ligne permettant au Patient ou à son
            Représentant légal, de s’opposer aux traitements de données les
            concernant réalisées par le CHU de Toulouse.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal peut avoir accès à ce service à
            distance à partir de l’un de ses terminaux personnels (ordinateur,
            tablette ou téléphone portable).
          </Typography>
          <Typography variant="body1">
            Ce service permet donc au Patient ou à son Représentant légal :
            <br />
            - D’être clairement informé desdits traitements et de la Recherche
            réalisées au CHU de Toulouse
            <br />
            - De garantir la matérialité de l’information délivrée et reçue et
            du choix fait
            <br />
            - De conserver l’historique des choix du Patient ou de son
            Représentant Légal
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Prérequis</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Le Patient ou son Représentant légal ne peut être qu’une personne
            physique.
          </Typography>
          <Typography variant="body1">
            Il déclare et garantit qu’il a la capacité juridique d’utiliser la
            Plateforme pour référencer ses choix dans les traitements de ses
            données effectués par le CHU de Toulouse.
          </Typography>
          <Typography variant="body1">
            Si le Patient ne dispose pas de la capacité juridique, le
            Représentant légal peut utiliser le service pour le compte du
            Patient tiers à la condition de disposer de l’autorité parentale, ou
            d’être le Curateur ou le tuteur du Patient au sens des dispositions
            législatives ou réglementaires.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal peut bénéficier des services
            proposés sur la Plateforme sous réserve de respecter les prérequis
            suivants, dans l’hypothèse où il se connecterait à la Plateforme à
            l’aide de son terminal personnel ;
            <br />
            - Disposer d’un terminal informatique (téléphone, tablette ou
            ordinateur) adapté pour accéder à la plateforme ;
            <br />
            - Disposer d’un accès Internet dont le coût reste à la charge du
            Patient ou de son Représentant légal ;
            <br />
            - Disposer d’une adresse de courrier électronique active ;
            <br />
            - Disposer d’un téléphone portable personnellement attribué ;
            <br />
            <br />
            La Plateforme est accessible et responsive sur tous les smartphones.
            Cependant, pour plus de lisibilité, il est conseillé d’utiliser une
            tablette ou un ordinateur. La Plateforme fonctionne avec tous les
            navigateurs. Cependant, le CHU de Toulouse recommande d’utiliser le
            navigateur Chrome pour une meilleure optimisation
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">
          Utilisation du service E-Consentement
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Pré-inscription en ligne effectuée par l’établissement
            </span>
            {" "}
            : A l’issue de son entrée dans l’établissement, le dossier du
            patient est créé dans la plateforme de e-consentement.
          </Typography>
          <Typography variant="body1">
            Le patient reçoit alors ses modalités de connexion au portail soit
            par Email soit par SMS en fonction des informations disponibles dans
            son dossier patient.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Parcours patient
            </span>
          </Typography>
          <Typography variant="body1">
            <span style={{ fontWeight: "bold" }}>
              1. Une adresse électronique et un numéro de téléphone sont
              enregistrés dans le dossier du patient
            </span>
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Réception du mail de recueil
            </span>
          </Typography>
          <Typography variant="body1">
            Le patient reçoit un email l’invitant à donner ses consentements
            RGPD. Le lien est personnalisé pour chaque patient.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Authentification
            </span>
          </Typography>
          <Typography variant="body1">
            Après avoir cliqué sur le lien du mail de recueil, le patient
            s’authentifie sur la plateforme.
          </Typography>
          <Typography variant="body1">
            - L’authentification du patient se déroule en plusieurs étapes :
            <br />
            - Contrôle de la date de naissance
            <br />
            - Choix de la situation : patient ou responsable légal du patient
            <br />
            <br />
            Authentification à deux facteurs : le patient reçoit un OTP le
            numéro de téléphone portable enregistré par l’établissement et
            rentre ce code dans la plateforme pour terminer l’authentification.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Recueil des non-opposition
            </span>
          </Typography>
          <Typography variant="body1">
            Le patient sélectionne la réponse correspondant à son choix (Je ne
            m’oppose pas / Je m’oppose) via un bouton positionné par défaut à
            “Je ne m’oppose pas”.
          </Typography>
          <Typography variant="body1">
            Après validation, les réponses sont alors enregistrées, Docaposte
            réalise une notarisation et génère un fichier de preuve qui sera
            stocké dans nos datacenters HDS. Le patient visualise alors une page
            de succès et reçoit un mail de confirmation.
          </Typography>
          <Typography variant="body1">
            En revanche, puisqu’il s’agit de non-opposition, si le patient ne se
            connecte pas au portail dans un délai de 30 jours fixé par
            l’établissement, après ce délai on considérera que le patient ne
            s’est pas opposé à la finalité.
          </Typography>
          <Typography variant="body1">
            <span style={{ fontWeight: "bold" }}>
              2. Seulement une adresse électronique est enregistrée dans le
              dossier du patient
            </span>
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Réception du mail de recueil
            </span>
          </Typography>
          <Typography variant="body1">
            Similaire au parcours précédent.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Authentification
            </span>
          </Typography>
          <Typography variant="body1">
            Après avoir cliqué sur le lien du mail de recueil, le patient
            s’authentifie sur la plateforme.
          </Typography>
          <Typography variant="body1">
            L’authentification du patient se déroule en plusieurs étapes :
            <br />
            Contrôle de la date de naissance
            <br />
            Choix de la situation : patient ou responsable légal du patient
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Authentification
            </span>
          </Typography>
          <Typography variant="body1">
            Le patient reçoit un OTP EMAIL sur l’adresse électronique
            enregistrée par l’établissement et rentre ce code dans la plateforme
            pour terminer l’authentification.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Recueil des non-opposition
            </span>
          </Typography>
          <Typography variant="body1">
            Similaire au parcours précédent.
          </Typography>
          <Typography variant="body1">
            <span style={{ fontWeight: "bold" }}>
              3. Seulement un numéro de téléphone est enregistré dans le dossier
              du patient
            </span>
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Réception du SMS de recueil
            </span>
          </Typography>
          <Typography variant="body1">
            Le patient reçoit un SMS l’invitant à donner ses consentements RGPD.
            Le lien est personnalisé pour chaque patient.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Ecran intermédiaire
            </span>
          </Typography>
          <Typography variant="body1">
            Après avoir cliqué sur le lien du SMS de recueil, le patient arrive
            sur un écran intermédiaire qui reprend le même contenu informatif
            que l’email de recueil, afin que les patients aient le même niveau
            d’information indépendamment de leur parcours.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Authentification
            </span>
          </Typography>
          <Typography variant="body1">
            L’authentification du patient se déroule en plusieurs étapes :
            <br />
            - Contrôle de la date de naissance
            <br />
            - Choix de la situation : patient ou responsable légal du
            patient
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Recueil des non-opposition
            </span>
          </Typography>
          <Typography variant="body1">
            Similaire au parcours précédent en dehors de la réception d’un mail
            de confirmation.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Modifications des choix du patient</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Si le patient souhaite modifier ses choix, il doit se reconnecter au
            portail ou contacter directement le DPO de l’établissement.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>
              Connexion au portail
            </span>
          </Typography>
          <Typography variant="body1">
            A partir du mail de confirmation
          </Typography>
          <Typography variant="body1">Identification</Typography>
          <Typography variant="body1">
            Le patient devra utiliser son IPP comme identifiant
          </Typography>
          <Typography variant="body1">
            Il doit sélectionner son établissement présent dans le menu
            déroulant.
          </Typography>
          <Typography variant="body1">
            Il doit saisir sa date de naissance.
          </Typography>
          <Typography variant="body1">
            Saisir un code OTP SMS ou Email*
          </Typography>
          <Typography variant="body1">
            *OTP SMS si son numéro de mobile a été recueilli par l’établissement
            ou OTP Email si son numéro de mobile n’a pas été recueilli.
          </Typography>
          <Typography variant="body1">
            <span style={{ textDecoration: "underline" }}>Modification</span>
          </Typography>
          <Typography variant="body1">
            Une fois l’authentification terminée, le patient peut modifier ses
            choix via le bouton disponible à cet effet : Autoriser ou S’opposer,
            en fonction du choix initial du patient.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">
          Entrée en vigueur, durée et opposabilité
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Cependant, le Patient ou son Représentant légal est informé que les
            données traitées sont conservées parle CHU de Toulouse pendant une
            durée de vingt (20) ans.
          </Typography>
          <Typography variant="body1">
            En tout état de cause, la version des conditions générales
            d’utilisation applicable au Patient ou son Représentant légal est
            celle acceptée par celui-ci au moment de sa connexion.
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse se réserve le droit d’adapter ou de modifier les
            présentes conditions générales à tout moment pour des raisons
            législatives et/ou d’évolution de sa plateforme.
          </Typography>
          <Typography variant="body1">
            Dans une telle hypothèse, il appartient au Patient ou son
            Représentant légal prendre connaissance des nouvelles conditions
            générales d’utilisation actualisées lors de son accès ultérieur à
            l’entrée en vigueur des nouvelles conditions générales
            d’utilisation.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">
          Obligations du Patient ou de son Représentant légal
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Le Patient ou son Représentant légal s’engage à respecter les
            conditions générales d’utilisation et à utiliser la plateforme de
            façon loyale, en agissant de manière compatible avec cette dernière
            et les législations et réglementations en vigueur.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal s’engage à prendre toutes les
            précautions nécessaires afin de protéger l’ensemble de son système
            informatique et ses terminaux de l’intrusion illicite dans son
            système informatique ou de toute contamination par des virus. Le CHU
            de Toulouse ne pourra pas voir sa responsabilité engagée à ce titre.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal s’oblige à ne pas porter
            atteinte à l’intégrité physique ou informatique du serveur ou des
            serveurs en usant de programmes, de fichiers infectés par des virus
            ou tous autres programmes informatiques de même nature qui seraient
            susceptibles de perturber le fonctionnement du service.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal s’interdit notamment de
            réaliser toute opération visant à saturer une page, les opérations
            de rebond ou toute opération ayant pour conséquence d’entraver ou de
            fausser le fonctionnement du Site, et toute action qui imposerait
            une charge disproportionnée sur les infrastructures du Site.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal s’interdit tout comportement
            illégal ou constitutif d’une fraude à l’égard du CHU de Toulouse,
            d’autres Patients et/ou des Professionnels de santé.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal doit sous sa seule
            responsabilité, souscrire les abonnements de télécommunications
            nécessaires à l’accès à la plateforme.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal est seul responsable de
            l’utilisation qu’il fait des services proposés par le CHU de
            Toulouse
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Obligations du CHU de Toulouse</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            <span style={{ fontSize: 10, marginRight: 5 }}>&#9679;</span>
            <span style={{ textDecoration: "underline" }}>Accessibilité</span>
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse s’engage à assurer l’accessibilité à ses services
            24h/24h et 7j/7j, à l’exception des périodes de maintenance et des
            cas de force majeure tel que défini à l’article 1218 du code civil.
            Le CHU de Toulouse s’engage à mettre en œuvre les moyens adaptés
            pour maintenir le service dans des conditions opérationnelles
            optimales.
          </Typography>
          <Typography variant="body1">
            Le Patient ou son Représentant légal est informé que la connexion
            aux services s’effectue via le réseau Internet. Il est averti des
            aléas techniques qui peuvent affecter ce réseau et entraîner des
            ralentissements ou des indisponibilités rendant la connexion
            impossible. Le CHU de Toulouse ne peut être tenu responsable des
            difficultés d’accès aux services dus à des perturbations du réseau
            Internet.
          </Typography>
          <Typography variant="body1">
            En cas de faille de sécurité constatée par le CHU de Toulouse, de
            nature à compromettre gravement la sécurité de la plateforme, le CHU
            de Toulouse pourra procéder à une interruption momentanée des
            services afin de remédier à la faille de sécurité dans les meilleurs
            délais.
          </Typography>
          <Typography variant="body1">
            Dans l’hypothèse où le Patient ou son Représentant légal
            rencontrerait un problème technique lié à la plateforme (de
            connexion, de fonctionnement), il pourra contacter le service
            support de CHU DE TOULOUSE :
            <a href="mailto:Support-consentement@chu-toulouse.fr">
              Support-consentement@chu-toulouse.fr
            </a>
          </Typography>
          <Typography variant="body1">
            <span style={{ fontSize: 10, marginRight: 5 }}>&#9679;</span>
            <span style={{ textDecoration: "underline" }}>Sécurité</span>
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse s’engage à mettre en œuvre les moyens nécessaires
            afin d’assurer la conservation et l’intégrité physique du contenu
            hébergé. Le CHU de Toulouse fait ses meilleurs efforts, conformément
            aux règles de l’art, pour sécuriser les données se rapportant au
            compte du Patient ou de son Représentant légal, au regard du risque
            encouru et de la nature des données traitées, dans le respect des
            dispositions des articles L.1111-8 et L.1110-4-1du Code de la santé
            publique par l’intermédiaire de son hébergeur de données de santé,
            OVH Healthcare.
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse a recours au prestataire de service de confiance
            Docaposte pour la mise en œuvre du procédé de dématérialisation du
            consentement par signature électronique, lequel garantit la
            conformité aux dispositions des articles 1367 du Code civil, L.
            1111-28 et L.1111-30 du Code de la santé publique..
          </Typography>
          <Typography variant="body1">
            <span style={{ fontSize: 10, marginRight: 5 }}>&#9679;</span>
            <span style={{ textDecoration: "underline" }}>
              Exonération de responsabilité
            </span>
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse ne saurait être responsable du bon fonctionnement
            de l’équipement informatique, de la tablette ou du téléphone
            portable du Patient ou de son Représentant légal ainsi que de son
            accès à internet ou à un réseau de téléphonie mobile.
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse n’est pas responsable des dommages de toute
            nature qui peuvent résulter d’une indisponibilité temporaire de la
            plateforme E-Consentement ou des services qui y sont associés.
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse ne peut être tenue pour responsable d’erreurs de
            saisie ou d’une mauvaise identification du Patient ou de son
            Représentant légal avant sa connexion à la Plateforme.
          </Typography>
          <Typography variant="body1">
            Le CHU de Toulouse ne saurait être tenu responsable envers le
            Patient ou son Représentant légal :
            <br />
            - Des dommages de toute nature résultant d’une mauvaise utilisation
            du Service, d’un usage inapproprié ou du non-respect des règles de
            sécurité ;
            <br />
            - D’actes résultant de la négligence du Patient ou de son
            Représentant légal ;
            <br />
            - D’actes non conformes aux présentes conditions générales
            d’utilisation ou contraires à la législation en vigueur ;
            <br />
            - D’une perturbation, d’une indisponibilité temporaire ou de
            l’impossibilité d’utiliser la Plateforme E-Consentement ne relevant
            pas du CHU de Toulouse ;
            <br />
            - D’un cas de force majeure. De façon expresse, sont seuls
            considérés comme cas de force majeure, ceux habituellement retenus
            par la jurisprudence des cours et tribunaux français, et les grèves
            externes tels que prévus par l’article 1218 du code civil ;
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Propriété intellectuelle</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Les présentes conditions générales d’utilisation n’emportent aucune
            cession d’aucune sorte de droits de propriété intellectuelle sur les
            éléments appartenant à CHU DE TOULOUSE au bénéfice Patient ou de son
            Représentant légal.
          </Typography>
          <Typography variant="body1">
            Le Site, les marques, les dessins, les modèles, les images, les
            textes, les photos, les logos, les chartes graphiques, les
            logiciels, les moteurs de recherche, les bases de données et les
            noms de domaine, sans que cette liste soit exhaustive, sont la
            propriété exclusive de CHU DE TOULOUSE ou de ses partenaires
            concédants.
          </Typography>
          <Typography variant="body1">
            Toute reproduction et/ou représentation, totale ou partielle d’un de
            ces droits, sans l’autorisation expresse de CHU DE TOULOUSE, est
            interdite et constituerait une contrefaçon sanctionnée par les
            articles L. 335-2 et suivants du Code de la propriété
            intellectuelle.
          </Typography>
          <Typography variant="body1">
            Le Patient ou de son Représentant légal s’interdit d’extraire, de
            copier, de modifier, d’adapter, d’accéder aux codes sources du Site
            et de la plateforme E-Consentement, de faire évoluer le logiciel
            intégré. Tout acte contraire serait constitutif de contrefaçon.
          </Typography>
          <Typography variant="body1">
            En conséquence, le Patient ou de son Représentant légal s’interdit
            tout agissement et tout acte susceptible de porter atteinte
            directement ou non aux droits de propriété intellectuelle de CHU de
            Toulouse.
          </Typography>
          <Typography variant="body1">
            CHU de Toulouse conservera la propriété des méthodes et du
            savoir-faire ou des outils qui lui sont propres ayant servi à
            proposer et réaliser les services offerts par le biais de la
            plateforme E-Consentement.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">
          Confidentialité et hébergement de données de santé
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Le CHU de Toulouse a recours à un hébergeur agréé, Docaposte
            exerçant l’activité d’hébergement de données de santé à caractère
            personnel au sens de l’article L. 1111-8 du Code de la santé
            publique, lequel a obtenu une certification délivrée par le ministre
            de la santé le 25 août 2020.
          </Typography>
          <Typography variant="body1">
            En tant qu’intermédiaire, Docaposte se conforme au plus strict
            secret professionnel et médical conformément au code de la santé
            publique en ce qui concerne les données de santé à caractère
            personnel dont il pourrait avoir connaissance dans le cadre de
            l’exécution des présentes conditions générales d’utilisation,
            conformément aux dispositions des articles 226-13 et 226-14 du code
            pénal etR.4127-4 du code de la santé publique.
          </Typography>
          <Typography variant="body1">
            Les informations transmises ou recueillies par le CHU de Toulouse
            l’occasion de l’utilisation du Site et du Service sont considérées
            par nature comme confidentielles et relevant du secret professionnel
            et du secret médical et ne font l’objet d’aucune communication
            extérieure, sauf autorisée par les dispositions législatives et
            réglementaires.
          </Typography>
          <Typography variant="body1">
            Cette disposition ne fait pas obstacle aux communications ordonnées
            par voie judiciaire ou administrative
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Convention de preuve</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            En acceptant les présentes, le Patient ou son représentant légal
            accepte expressément :
            <br />
            - que les fichiers numériques, traces informatiques (par exemple
            historiques de connexion, logs techniques, traces applicatives,
            traces cryptographiques, accusés de réception, horodatage, etc.) et
            les échanges numériques soient opposables et admissibles devant les
            juridictions et fassent preuve des données et des éléments qu’ils
            contiennent ;
            <br />
            - que les éléments d’identification et d’authentification utilisés
            dans le cadre de ce traitement parle CHU de Toulouse soient
            opposables et admissibles devant les juridictions et fassent preuve
            des données et des éléments qu’ils contiennent ainsi que des
            procédés d’identification et d’authentification qu’ils expriment ;
            <br />
            - que les éléments d’horodatage numérique soient opposables et
            admissibles devant les juridictions et fassent preuve des données et
            des éléments qu’ils contiennent ;
          </Typography>
          <Typography variant="body1">
            Il est toutefois possible pour le patient ou le Représentant légal
            de rapporter les preuves contraires par tous moyens.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Langue, loi applicable</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Le français est la langue unique et obligatoire du Site.
          </Typography>
          <Typography variant="body1">
            Les présentes conditions générales d’utilisation sont régies par la
            loi française.
          </Typography>
          <Typography variant="body1">
            Il en est ainsi pour les règles de fond et les règles de forme et
            ce, nonobstant les lieux d’exécution des obligations substantielles
            ou accessoires.
          </Typography>
        </Box>
      </Box>
      <Typography variant="h2">
        Protection des données à caractère personnel
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography variant="body1">
          Le Centre Hospitalier de Toulouse est soucieux de préserver la
          protection des données, la confidentialité et la sécurité de données
          personnelles et attache une grande importance à la protection de la
          vie privée.
        </Typography>
        <Typography variant="body1">
          Les Données personnelles sont collectées par le CHU de Toulouse, en
          tant que responsable de traitement au sens du Règlement Général sur la
          Protection des Données (ci-après « RGPD ») et de la loi n°2018-493du
          20 juin 2018 relative à la protection des données modifiant la loi
          n°78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et
          aux libertés modifiées.
        </Typography>
        <Typography variant="body1">
          <span style={{ textDecoration: "underline" }}>
            Données collectées
          </span>
          {' '}
          :
        </Typography>
        <Typography variant="body1">
          Les Données personnelles pouvant être traitées sont les suivantes :
        </Typography>
        <Typography variant="body1">
          Données d’identité notamment : IPP, adresse e-mail, adresse postale,
          numéro de téléphone, date et ville de naissance, nom et prénom,
          civilité et date de venue au CHU de Toulouse.
        </Typography>
        <Typography variant="body1">
          Durée de conservation : Le CHU de Toulouse conserve votre choix et les
          données inhérentes à ce traitement pendant une durée de vingt (20)
          ans.
        </Typography>
        <Typography variant="body1">
          Les données administratives sont conservées de manière sécurisée
          pendant la même durée que le dossier médical.
        </Typography>
        <Typography variant="body1">
          <span style={{ textDecoration: "underline" }}>
            Destinataires des Données :
          </span>
        </Typography>
        <Typography variant="body1">
          Vos données personnelles sont destinées uniquement aux services
          habilités du responsable de traitement. En ce sens, les services
          administratifs habilités du CHU de Toulouse dans la limite de leurs
          missions pour ledit traitement, le cas échéant aux organismes de
          tutelles ou établissement exerçant une mission de service public dans
          les conditions prévues par la loi.
        </Typography>
        <Typography variant="body1">
          De plus, vos données à caractère personnel collectées pourront être
          communiquées à nos prestataires de service qui sont des sous-traitants
          au sens du Règlement Général de la Protection des Données. Le CHU de
          Toulouse ne travaille qu’avec des sous-traitants qui présentent des
          garanties suffisantes quant à la mise en œuvre de mesures techniques
          et organisationnelles appropriées de manière que le traitement réponde
          aux exigences de la règlementation applicable et garantisse de la
          protection de vos droits, en ce sens Docaposte qui administre et
          hébergement ladite Plateforme.
        </Typography>
        <Typography variant="body1">
          Dans tous les cas : l’accès aux Données par ces destinataires et
          sous-traitants est limité aux catégories de données qui leur sont
          strictement nécessaires pour leur mission, et ces derniers sont soumis
          au secret professionnel ou à une obligation contractuelle de
          confidentialité.
        </Typography>
        <Typography variant="body1">
          <span style={{ textDecoration: "underline" }}>
            Les transferts de données
          </span>
        </Typography>
        <Typography variant="body1">
          Le CHU de Toulouse est susceptible d’échanger les données personnelles
          collectées en son sein.
        </Typography>
        <Typography variant="body1">
          Sur instructions du responsable de traitement, les sous-traitants sont
          amenés à accéder aux données collectées ; ils agissent à des fins de
          fourniture de biens et de services, de développement, de gestion et
          d’amélioration de la Plateforme.
        </Typography>
        <Typography variant="body1">
          Aucune donnée à caractère personnel n’est transférée dans un pays hors
          Union Européenne.
        </Typography>
        <Typography variant="body1">
          Il convient de préciser que toute donnée personnelle peut faire
          l’objet d’un transfert si elle est nécessaire à la constatation, à
          l’exercice ou la défense de droits en justice ainsi que pour des
          motifs d’intérêt publics
        </Typography>
        <Typography variant="body1">
          <span style={{ textDecoration: "underline" }}>
            Exercice des droits RGPD
          </span>
        </Typography>
        <Typography variant="body1">
          Vous disposez de plusieurs droits individuels sur vos données
          personnelles communiquées, en particulier : un droit d’accès, de
          rectification, d’effacement, un droit à la limitation des traitements,
          un droit d’opposition du traitement, un droit à l’oubli.
        </Typography>
        <Typography variant="body1">
          Le CHU de Toulouse s’engage à vous notifier, quand vous avez
          communiqué des données à caractère personnel, toute rectification,
          effacement, limitation (article 19 du RGPD). Nous nous réservons le
          droit de ne pas exercer cette obligation si la base légale du
          traitement ne permet pas d’exercer ces droits ou si cela entraine des
          formalités, coûts et démarches disproportionnés.
        </Typography>
        <Typography variant="body1">
          Vous pouvez exercer vos droits à l’adresse e-mail dpo@chu-toulouse.fr
          ou par courrier postal à l’adresse postale suivante : Hôtel Dieu
          Saint-Jacques, Service Qualité, Déléguée à la Protection des Données –
          2 rue Viguerie, 31059 Toulouse Cedex 9, France. Votre demande devra
          indiquer votre nom et prénom, adresse-mail ou postale, être signée et
          accompagnée d’un justificatif d’identité en cours de validité.
        </Typography>
        <Typography variant="body1">
          Si vous estimez, après nous avoir contactés, que vos droits
          Informatique et Libertés ne sont pas respectés, vous pouvez adresser
          une réclamation à la Commission Nationale de l’Informatique et des
          Libertés(www.cnil.fr)
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Cookies</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">Qu’est-ce qu’un cookie ?</Typography>
          <Typography variant="body1">
            Un cookie est un fichier déposé sur votre ordinateur, ou tout
            périphérique utilisé pour la consultation Internet, par le site que
            vous visitez, afin de transmettre par exemple, des informations de
            session de page en page, ou encore enregistrer votre passage sur
            telle ou telle page, dans le but d’optimiser votre navigation, en
            termes de confort, d’efficacité et de pertinence.
          </Typography>
          <Typography variant="body1">
            Les informations stockées par les cookies, pendant une durée
            limitée, sont anonymes et portent sur les pages visitées et le temps
            passé sur chacune, votre équipement de navigation (système
            d’exploitation, navigateur, résolution…), les recherches effectuées,
            votre adresse IP afin de permettre des regroupements approximatifs
            par zone géographique, etc.
          </Typography>
          <Typography variant="body1">
            Pour en savoir plus sur les cookies, vous pouvez vous rendre sur le
            site de la CNIL :
            {" "}
            <a href="https://www.cnil.fr/fr/cookies-et-autres-traceurs/">
              https://www.cnil.fr/fr/cookies-et-autres-traceurs/
            </a>
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h3">Gestion des cookies</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            Le site ne dépose aucun cookie sur votre ordinateur.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
